import { render, staticRenderFns } from "./ServicoList.vue?vue&type=template&id=17773dac&"
import script from "./ServicoList.vue?vue&type=script&lang=js&"
export * from "./ServicoList.vue?vue&type=script&lang=js&"
import style0 from "./ServicoList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports